import { combineReducers } from "redux";
import contact from "../features/admin/contactus/contact/Slice";

const contactus = combineReducers({
  contact: contact,
});

export default contactus;
